import { useEffect, useState } from "react";
import { useAmplitude } from "@crehana/analytics";
import { KEY_NAMES } from "@crehana/ui";
const useActiveSubmenu = ({ amplitudePageName, onLeftMenuClick, onChangeActiveSubmenu })=>{
    const { logEvent } = useAmplitude();
    const [activeSubMenu, setActiveSubMenu] = useState();
    useEffect(()=>{
        if (onChangeActiveSubmenu) onChangeActiveSubmenu(activeSubMenu);
    }, [
        activeSubMenu,
        onChangeActiveSubmenu
    ]);
    useEffect(()=>{
        function handleKeyDown(e) {
            if (e.key === KEY_NAMES.ESCAPE) setActiveSubMenu((prevActiveSubmenu)=>'search' === prevActiveSubmenu ? prevActiveSubmenu : void 0);
        }
        window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const onLeftMenuOpen = ()=>{
        if ('function' == typeof onLeftMenuClick) onLeftMenuClick();
        else setActiveSubMenu('left-menu-drawer');
    };
    const onCatalogMenuOpen = ()=>{
        setActiveSubMenu('catalog-menu');
    };
    const onResourcesMenuOpen = ()=>{
        setActiveSubMenu('resources-menu');
    };
    const onSearchMenuOpen = ()=>{
        setActiveSubMenu('search');
        logEvent({
            event: 'Search Opened',
            data: {
                Source: amplitudePageName
            }
        });
    };
    const onShoppingCartOpen = ()=>{
        setActiveSubMenu('shopping-cart-popper');
    };
    const onNotificationsOpen = ()=>{
        setActiveSubMenu('notifications-drawer');
    };
    const onUserMenuOpen = ()=>{
        setActiveSubMenu('user-menu');
    };
    const onCloseSubmenu = ()=>{
        setActiveSubMenu(void 0);
    };
    const onToggleSubmenu = (submenu)=>{
        if (activeSubMenu === submenu) onCloseSubmenu();
        else setActiveSubMenu(submenu);
    };
    return {
        activeSubMenu,
        onLeftMenuOpen,
        onCatalogMenuOpen,
        onResourcesMenuOpen,
        onSearchMenuOpen,
        onShoppingCartOpen,
        onNotificationsOpen,
        onUserMenuOpen,
        onCloseSubmenu,
        onToggleSubmenu
    };
};
const hooks_useActiveSubmenu = useActiveSubmenu;
export default hooks_useActiveSubmenu;
